export const HEADER_HEIGHT = 118;
export const TOP_NUDGE_HEIGHT = 48;
export const EXTENDED_TOP_NUDGE_HEIGHT = 320;
